const menuFunctions = () => {
    if ( $('.js-menus-inner-filter-section').length ) {
        ScrollTrigger.create({
            trigger: '.js-menus-inner-filter-section',
            start: () => {
                const headerHeight = $('.c-header__logo-row').outerHeight();
                return 'top top+=' + headerHeight;
            },
            endTrigger: '.menus',
            end: 'bottom bottom',
            pin: true,
            pinSpacing: false
        });
    }    
}